import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './App.css';
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Approach from "./components/Approach";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer"

function App() {
  return (
    <div >
<Navbar />
<Hero />
<About />
<Services />
<Approach />
<Pricing />
<Contact />
<Footer />

    </div>
  );
}

export default App;
